import styled from 'styled-components'
import themeGet from '@styled-system/theme-get'

import { LANDING_CONTENT_WIDTH_PX } from 'Constants/Landing'

export const Container = styled.div`
  display: flex;
  width: 100%;
  max-width: ${LANDING_CONTENT_WIDTH_PX}px;
  gap: ${themeGet('space.9')}px;
`

export const FormHolder = styled.div`
  width: 100%;
  max-width: 300px;
  min-height: 738px;
`

export const ImageHolder = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  border-radius: 20px;
  overflow: hidden;

  > img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`
